import { MinLength, MaxLength } from "class-validator";
import {validate, validateOrReject, Contains, IsInt, Length, IsEmail, IsFQDN,
        IsDate,Min,Max } from "class-validator"; 
import {ValidateIf, IsNotEmpty,IsNumber,IsString,IsEmpty } from "class-validator"; 


export class Stkma { 
    @MaxLength(10,{message: 'COMPANY 字串太長'}) 
    @IsString({message: 'COMPANY 不是字串型態'}) 
    COMPANY: string = ""; 
  
    @MaxLength(10) 
    CREATOR: string = ""; 
  
    @MaxLength(10) 
    USR_GROUP: string = ""; 
  
    @MaxLength(8) 
    CREATE_DATE: string =""; 
  
    @MaxLength(10) 
    MODIFIER: string = ""; 
  
    @MaxLength(8) 
    MODI_DATE: string = ""; 
  
    @IsNumber() 
    @Max(999) 
    FLAG: number =0; 


    @IsNotEmpty({message: '股票代號 (MA001) 不可空白'}) 
    @MaxLength(20,{message: '股票代號 (MA001) 資料太長'})
    MA001: string = '';            // 股票代號 20 搭配STKTM

    @MaxLength(20,{message: '名稱 (MA002) 資料太長'})
    MA002: string = '';            // 名稱 20 

    @IsNumber() 
    MA003: number = 0.6;            // 融資乘數 5.3 [DEF:0.6]

    @MaxLength(20,{message: '期貨/股票代號 (MA004) 資料太長'})
    MA004: string = '';            // 期貨/股票代號 20 

    @MaxLength(20,{message: '小型期貨代號 (MA005) 資料太長'})
    MA005: string = '';            // 小型期貨代號 20 

    @MaxLength(100,{message: '摘要 (MA006) 資料太長'})
    MA006: string = '';            // 摘要 100 

    @IsNumber() 
    MA013: number = 0.9;            // 融券乘數 5.3 [DEF:0.9]  上櫃 1.0

    @MaxLength(1,{message: '長期投資 (MA015) 資料太長'})
    MA015: string = 'N';            // 長期投資 1 [DEF:"N"]

    @IsNumber() 
    MA017: number = 0;            // 原始保證金適用比例 5.4 

    @MaxLength(1,{message: '商品分類 (MA019) 資料太長'})
    MA019: string = '0';            // 商品分類 1 [DEF:"0"] JCKMD STKMA.MA019 {{0:上市 1:上櫃 2:期貨 3:選擇權 4:興櫃 5:盤中零股-上市 6:盤中零股-上櫃  O:海期 Z:指數}}

    @MaxLength(1,{message: '刪除 (MA020) 資料太長'})
    MA020: string = 'N';            // 刪除 1 [DEF:"N"]

    @MaxLength(1,{message: '夜盤 (MA021) 資料太長'})
    MA021: string = 'N';            // 夜盤 1 [DEF:"N"]  {{N:日盤 Y:夜盤 U.美股}}

    @IsNumber() 
    MA022: number = 0.003;            // 證交稅率% 10.6 [DEF:0.003]

    @MaxLength(20,{message: 'XQ股票代號 (MA028) 資料太長'})
    MA028: string = '';            // XQ股票代號 20 

    @MaxLength(10,{message: 'XQ次標題 (MA029) 資料太長'})
    MA029: string = '';            // XQ次標題 10 STK.ME001

    @MaxLength(8,{message: '市價日期 (MA030) 資料太長'})
    MA030: string = '';            // 市價日期 8 

    @MaxLength(8,{message: '市價時間 (MA031) 資料太長'})
    MA031: string = '';            // 市價時間 8 

    @IsNumber() 
    MA033: number = 1;            // 正反向 2 [DEF:1] {{1:正向 -1:反向}}

    @MaxLength(16,{message: '商品下單代碼 (MA034) 資料太長'})
    MA034: string = '';            // 商品下單代碼 16 

    @MaxLength(10,{message: '交易所下單代碼 (MA035) 資料太長'})
    MA035: string = '';            // 交易所下單代碼 10 STK.ME001

    @MaxLength(8,{message: '期貨結算日 (MA036) 資料太長'})
    MA036: string = '';            // 期貨結算日 8 

    @IsNumber() 
    MA043: number = 0;            // stockIndex 8.3 capitalAPI stockIndex

    @IsNumber() 
    MA044: number = 0;            // 最新股本 8.3 

    @IsNumber() 
    MA045: number = 0;            // 保留 8.3 

    @MaxLength(8,{message: '群益期貨對帳代號 (MA046) 資料太長'})
    MA046: string = '';            // 群益期貨對帳代號 8 統計日期

    @MaxLength(500,{message: '群組 (MA047) 資料太長'})
    MA047: string = '';            // 群組 500 依群組排序

    @MaxLength(10,{message: '交易所代號 (MA048) 資料太長'})
    MA048: string = '';            // 交易所代號 10 

    @MaxLength(60,{message: '交易所名稱 (MA049) 資料太長'})
    MA049: string = '';            // 交易所名稱 60 

    @MaxLength(4,{message: '時間起 (TIME1) 資料太長'})
    TIME1: string = '';            // 時間起 4 

    @MaxLength(4,{message: '時間迄 (TIME2) 資料太長'})
    TIME2: string = '';            // 時間迄 4 

    @MaxLength(4,{message: '夜盤起 (TIME3) 資料太長'})
    TIME3: string = '';            // 夜盤起 4 

    @MaxLength(4,{message: '夜盤迄 (TIME4) 資料太長'})
    TIME4: string = '';            // 夜盤迄 4 


}
